import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';
import { getQuery } from '@/helpers/utils';

export const calculatorService = {
  constants: () => axios.get(Pathes.Calculator.constants),
  growth: params => axios.get(Pathes.Calculator.growth + getQuery(params)),
  didYouKnow: params =>
    axios.get(Pathes.Calculator.didYouKnow + getQuery(params)),
};
